import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import BusinessAOI from "@/views/base/components/BusinessAOI.vue";
export default {
  components: {
    BusinessAOI: BusinessAOI
  },
  data: function data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        districtId: this.$route.query.districtId
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      // 表单
      form: {},
      dialogVisible: false,
      // 弹窗状态
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  computed: {
    title: function title() {
      var _this$$route$query = this.$route.query,
        cityName = _this$$route$query.cityName,
        name = _this$$route$query.name;
      return "".concat(cityName, "/").concat(name, "/\u5546\u5708");
    }
  },
  methods: {
    // 更新排序
    updateSort: function updateSort(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.updateBusinessOrderV3({
                id: row.id,
                order: row.weights
              });
            case 1:
              res = _context2.v;
              _this2.setResult(res, "排序已更新");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    getData: function getData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _res$data;
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getBusinessListV3(_this3.searchForm);
            case 1:
              res = _context3.v;
              _this3.tableData = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.content) || [];
              _this3.tableLoading = false;
              _this3.total = res.data.totalSize;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    showAOIMap: function showAOIMap(row) {
      this.form = row;
      this.$refs.aoi.edit(row, this.title + "/" + row.nameZh || "", this.$route.query.cityName);
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              res = {};
              if (!_this4.form.id) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return _this4.$api.updateBusinessV3(_this4.form);
            case 1:
              res = _context4.v;
              _context4.n = 4;
              break;
            case 2:
              _this4.form.districtId = _this4.$route.query.districtId;
              _context4.n = 3;
              return _this4.$api.addBusinessV3(_this4.form);
            case 3:
              res = _context4.v;
            case 4:
              _this4.setResult(res, "操作成功");
              _this4.dialogVisible = false;
              _this4.form = {};
              _this4.getData();
            case 5:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateStatus: function updateStatus(row) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              row.isShow = row.isShow == 1 ? 0 : 1;
              _context5.n = 1;
              return _this5.$api.updateBusinessV3(row);
            case 1:
              res = _context5.v;
              _this5.setResult(res, row.isShow ? "已关闭" : "已开放");
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteItem: function deleteItem(row) {
      var _this6 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$api.deleteBusinessV3(row.id);
            case 1:
              res = _context6.v;
              _this6.setResult(res, "已删除");
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      })));
    },
    setResult: function setResult(_ref2) {
      var data = _ref2.data;
      var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "操作成功";
      if (data) {
        this.$message.success(text);
        this.getData();
      }
    }
  }
};